/* eslint-disable */
import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Typography,
  Chip,
  Stack,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';
import SchoolIcon from '@mui/icons-material/School';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const PairingTable = ({
  tableData,
  isEndingTraining,
  isEndingPairing,
  setTrainingEndingPayload,
  setPairingEndingPayload,
}) => {
  const theme = useTheme();

  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <TableContainer 
      component={Paper} 
      sx={{ 
        mt: 2,
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        overflow: 'hidden',
      }}
    >
      {tableData?.length > 0 ? (
        <Table sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow
              sx={{
                background: 'linear-gradient(135deg, #569cd3 0%, #7DB8E5 100%)',
              }}
            >
              <TableCell
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '14px',
                  width: '60px',
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '14px',
                }}
              >
                Teacher
              </TableCell>
              <TableCell
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '14px',
                }}
              >
                Edifier
              </TableCell>
              <TableCell
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '14px',
                  width: '180px',
                }}
              >
                Paired Since
              </TableCell>
              <TableCell
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '14px',
                  width: '120px',
                  textAlign: 'center',
                }}
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '14px',
                  width: '200px',
                  textAlign: 'center',
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={row._id}
                sx={{
                  '&:nth-of-type(odd)': {
                    backgroundColor: 'rgba(86, 156, 211, 0.02)',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(86, 156, 211, 0.06)',
                  },
                  transition: 'background-color 0.2s ease',
                }}
              >
                {/* Index */}
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {index + 1}
                  </Typography>
                </TableCell>

                {/* Teacher Info */}
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Avatar
                      src={row['Teacher Image'] || undefined}
                      sx={{
                        width: 44,
                        height: 44,
                        background: row['Teacher Image']
                          ? 'transparent'
                          : 'linear-gradient(135deg, #A8469B 0%, #C567B8 100%)',
                        fontSize: '16px',
                        fontWeight: 700,
                      }}
                    >
                      {!row['Teacher Image'] && getInitials(row['Teacher Name'])}
                    </Avatar>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.3 }}>
                        <SchoolIcon sx={{ fontSize: 14, color: '#A8469B' }} />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            color: theme.palette.text.primary,
                            fontSize: '14px',
                            lineHeight: 1.2,
                          }}
                        >
                          {row['Teacher Name']}
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          color: theme.palette.text.secondary,
                          fontSize: '12px',
                          display: 'block',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {row['Teacher Email']}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>

                {/* Edifier Info */}
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Avatar
                      src={row['Edifier Image'] || undefined}
                      sx={{
                        width: 44,
                        height: 44,
                        background: row['Edifier Image']
                          ? 'transparent'
                          : 'linear-gradient(135deg, #569cd3 0%, #7DB8E5 100%)',
                        fontSize: '16px',
                        fontWeight: 700,
                      }}
                    >
                      {!row['Edifier Image'] && getInitials(row['Edifier Name'])}
                    </Avatar>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.3 }}>
                        <SupervisorAccountIcon sx={{ fontSize: 14, color: '#569cd3' }} />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            color: theme.palette.text.primary,
                            fontSize: '14px',
                            lineHeight: 1.2,
                          }}
                        >
                          {row['Edifier Name']}
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          color: theme.palette.text.secondary,
                          fontSize: '12px',
                          display: 'block',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {row['Edifier Email']}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>

                {/* Paired Since */}
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <CalendarMonthIcon
                      sx={{
                        fontSize: 18,
                        color: theme.palette.text.secondary,
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        color: theme.palette.text.primary,
                        fontSize: '13px',
                        fontWeight: 500,
                      }}
                    >
                      {row['Paired Since']}
                    </Typography>
                  </Box>
                </TableCell>

                {/* Status */}
                <TableCell sx={{ textAlign: 'center' }}>
                  {row.lastSession ? (
                    <Chip
                      label="Training Ended"
                      size="small"
                      sx={{
                        background: '#E0E0E0',
                        color: '#757575',
                        fontWeight: 600,
                        fontSize: '11px',
                        height: '26px',
                      }}
                    />
                  ) : (
                    <Chip
                      label="Active"
                      size="small"
                      sx={{
                        background: '#54D62C',
                        color: 'white',
                        fontWeight: 600,
                        fontSize: '11px',
                        height: '26px',
                      }}
                    />
                  )}
                </TableCell>

                {/* Actions */}
                <TableCell>
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <LoadingButton
                      variant="contained"
                      size="small"
                      loading={isEndingTraining}
                      disabled={row.lastSession || isEndingPairing}
                      onClick={() => setTrainingEndingPayload({ id: row._id })}
                      sx={{
                        minWidth: '85px',
                        height: '32px',
                        fontSize: '12px',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        background: row.lastSession ? '#E0E0E0' : '#54D62C',
                        color: row.lastSession ? '#757575' : 'white',
                        '&:hover': {
                          background: row.lastSession ? '#E0E0E0' : '#229A16',
                        },
                        '&.Mui-disabled': {
                          background: '#E0E0E0',
                          color: '#757575',
                        },
                      }}
                    >
                      {row.lastSession ? 'Ended' : 'End'}
                    </LoadingButton>

                    <LoadingButton
                      variant="outlined"
                      size="small"
                      loading={isEndingPairing}
                      onClick={() => setPairingEndingPayload({ ...row.usersInPair })}
                      sx={{
                        minWidth: '85px',
                        height: '32px',
                        fontSize: '12px',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        borderWidth: '1.5px',
                        borderColor: '#FF4842',
                        color: '#FF4842',
                        '&:hover': {
                          borderWidth: '1.5px',
                          borderColor: '#FF4842',
                          background: 'rgba(255, 72, 66, 0.08)',
                        },
                      }}
                    >
                      Unpair
                    </LoadingButton>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 1 }}>
            No Pairings Found
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Create your first pair to get started
          </Typography>
        </Box>
      )}
    </TableContainer>
  );
};

export default PairingTable;
